module.exports = __webpack_public_path__ + "static/media/Promos_DctoCeleb.242b9b14.png";